import '.n{width:100%;}.ssr-plugin'
import '.bd{padding-inline:1rem;}.ssr-plugin'
import '.d{display:flex;}.ssr-plugin'
import '.ax{justify-content:center;}.ssr-plugin'
import '.be{position:sticky;}.ssr-plugin'
import '.bf{top:0px;}.ssr-plugin'
import '.bg{z-index:10;}.ssr-plugin'
import '.bh{background:var(--nav-bg);}.ssr-plugin'
import '.d1{border-bottom:var(--border-subtle);}.ssr-plugin'
import '.eu{flex:1 1 auto;}.ssr-plugin'
import '.gs{overflow-x:auto;}.ssr-plugin'
import '.a4{min-width:0px;}.ssr-plugin'
import { styled } from 'inlines'
import { TabsGroup } from '@app/components/core/tabs/Tabs'
import { getTitleLevelStyle } from '@app/components/core/typography/styles'
import { TextLink } from '@app/components/core/link/TextLink'
import { ResponsiveContainer } from '@app/components/layout/ResponsiveContainer'

const ENTITY_NAME_APPEAR_ANIMATION = 'nav-account-appear 220ms ease-out'

export type GeographyNavBarTab = {
  value: string
  label: string
  isVisible: boolean
}

export type GeographyNavBarShellProps = {
  isMobile: boolean
  shouldShowEntityName: boolean
  entityName: string
  homePath: string
  tab: string
  tabs: GeographyNavBarTab[]
  onSelectTab: (key: string) => void
}

export const GeographyNavBarShell = ({
  isMobile,
  shouldShowEntityName,
  entityName,
  homePath,
  tab,
  tabs,
  onSelectTab,
}: GeographyNavBarShellProps) => (
  <nav className="n bd d ax be bf bg bh d1"
  >
    <ResponsiveContainer
      style={{
        background: 'var(--nav-bg)',
        display: 'flex',
        justifyContent: shouldShowEntityName ? 'space-between' : 'flex-end',
        alignItems: 'center',
        flexWrap: isMobile ? 'wrap' : 'nowrap',
        minHeight: '3.5rem',
        gap: isMobile ? '0.5rem' : '1rem',
      }}
    >
      {shouldShowEntityName ? (
        <TextLink
          to={homePath}
          textStyle={{
            fontFamily: 'var(--font-heading)',
            ...getTitleLevelStyle(3, isMobile),
            whiteSpace: 'nowrap',
          }}
          containerStyle={{
            textDecoration: 'none',
            animation: ENTITY_NAME_APPEAR_ANIMATION,
          }}
        >
          {entityName}
        </TextLink>
      ) : null}

      <div className="eu d gs a4"
        style={{
          justifyContent: isMobile ? 'flex-start' : 'flex-end',}}
      >
        <TabsGroup
          selectedTab={tab}
          onSelectTab={onSelectTab}
          maxVisibleTabs={isMobile ? 3 : 6}
          tabs={tabs}
          tabItemStyle={{
            padding: isMobile ? '1rem 0.75rem' : '1.25rem 1rem',
          }}
        />
      </div>
    </ResponsiveContainer>
  </nav>
)
